import { useState } from 'react';
import MuiTable from '../../../../common-utilities/core/mui-table';
import { getHeaderConfig } from './history-header-config';
import { setProperty } from '../../../../common-utilities/utils/misc';

const VendorMappingHistory = ({ history, loadData }) => {
  const [filters, setFilters] = useState({
    page: 1,
  });

  return (
    <MuiTable
      dataList={history?.results || []}
      columnsList={getHeaderConfig()}
      pageCount={history?.totalPages}
      filters={filters}
      onChange={(page) => {
        setProperty('page', page, setFilters);
        loadData(history.mainData, { page });
      }}
    />
  );
};

export default VendorMappingHistory;
